<div>
  <div class="spb-form-lead-text">{{ leadText }}</div>
  <mat-radio-group [formControl]="ctrl" color="primary" ngDefaultControl>
    <mat-radio-button value="ja">Ja</mat-radio-button>
    <mat-radio-button value="nej">Nej</mat-radio-button>
  </mat-radio-group>
</div>